// eslint-disable-next-line @nx/enforce-module-boundaries
import type { Checksum } from "@jnctn/api/app/fetchChecksums";
import type { Tenant } from "../contexts/TenantContext.native";

export default function useChecksumDefaults(
  accessToken: string | undefined,
  selectedChecksum: Checksum | undefined,
  tenant: Tenant | undefined,
  validChecksums: Checksum[]
) {
  if (accessToken && selectedChecksum === undefined) {
    const [firstValid] = validChecksums;
    tenant = firstValid.tenantName;
    selectedChecksum = firstValid;
  }
  return { defaultTenant: tenant, defaultSelectedChecksum: selectedChecksum };
}
